module.exports = __webpack_public_path__ + "img/SUPER-OK-VIPER-ROOM-11X17-small.63a954a4.jpg";